<template>
  <!--辞书培训班 新增- 编辑页面 -->
  <div class="container">
    <div class="el-form" v-loading="loading">
      <el-form :model="form" ref="form" :rules="rule">
        <el-form-item
          label="培训班ID: "
          v-show="detailId"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="detailId"
              :disabled="detailId != ''"
              autocomplete="off"
              width="120px"
              placeholder="请输入"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="培训班名称: "
          prop="title"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.title"
              :disabled='isView'
              autocomplete="off"
              :maxlength="maxlength"
              placeholder="请输入培训班名称"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="培训时间: "
          prop="startTime"
          :label-width="formLabelWidth"
        >
          <el-col :span="12">
            <el-date-picker
              v-model="form.startTime"
              :disabled='isView'
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item
          label="培训地点:"
          prop="address"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.address"
              :disabled='isView'
              :maxlength="maxlength"
              placeholder="请输入培训地点"
              autocomplete="off"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="报名时限:"
          prop="registStartTime"

          :label-width="formLabelWidth"
        >
          <el-col :span="12">
            <el-date-picker
              v-model="form.registStartTime"
              :disabled='isView'
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              :default-time="['00:00:00', '23:59:59']"
            >
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item
          label="报名人数:"
          prop="maxRegistNumber"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.maxRegistNumber"
              :disabled='isView'
              :maxlength="maxlength"
              placeholder="请输入报名人数"
              autocomplete="off"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="置顶顺序: "
          prop="sort"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              v-model="form.sort"
              :disabled='isView'
              onkeyup="value=value.replace(/[^\d]/g,'')"
              maxlength="4"
              autocomplete="off"
              placeholder="请输入置顶顺序,数值小的在最上面,最小值为1,默认9999"
            />
          </el-col>
        </el-form-item>

        <el-form-item
          label="报名须知: "
          prop="registRemind"
          :label-width="formLabelWidth"
        >
          <el-col :span="24">
            <el-input
              type="textarea"
              :disabled='isView'
              v-model="form.registRemind"
              autocomplete="off"
              maxlength="3000"
              :rows="3"
              show-word-limit
              placeholder="请输入报名须知"
            />
          </el-col>
        </el-form-item>

        <el-form-item label="">
          <el-col style="margin-left: 150px">
            <el-radio-group v-model="radioType" size="small">
              <el-radio-button :label="0">开班通知</el-radio-button>
              <el-radio-button :label="1">课程和任课老师</el-radio-button>
              <el-radio-button :label="2">小结</el-radio-button>
            </el-radio-group>
          </el-col>
        </el-form-item>

        <div v-if="radioType == '0'">
          <el-form-item
            label="通知标题:"
            prop="noticeTitle"
            :label-width="formLabelWidth"
          >
          <el-col :span="24">
              <el-input
                v-model="form.noticeTitle"
                :disabled='isView'
                :maxlength="maxlength"
                placeholder="请输入开班通知标题"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="作者:"
            prop="author"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="noticeNew.author"
                :disabled='isView'
                :maxlength="maxlength"
                placeholder="请输入作者"
                autocomplete="off"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="上传图片"
            ref="uploadPic"
            prop="uploadPic"
            class="div-upload-form-item address"
            :label-width="formLabelWidth"
          >
            <div class="div-upload-container" ref="uploadBottom">
              <el-upload
                ref="uploadImg1"
                accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
                list-type="picture-card"
                action=""
                multiple
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove"
                :on-change="handleChange"
                :before-upload="handleBefore"
                :on-exceed="handleExceed"
                :file-list="fileList"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">建议比例: W: H=5:3  建议尺寸:W*H=640*400 (px)</div>
              </el-upload>
            </div>
          </el-form-item>

          <el-form-item label="详情:" :label-width="formLabelWidth">
            <el-col :span="24">
              <tinymce
                styleName="width: 100%; height: 400px; margin: 5px auto; "
                id="tinymceId"
                :disabled='isView'
                @onChange="onChange1"
                :key="tinymceFlag1"
                :text="noticeNew.content"
                :url="form.newUrlStr"
              />
            </el-col>
          </el-form-item>

          <el-form-item label="" :label-width="formLabelWidth" prop="noticeNewMeeting">
            <el-col :span="24">
              <el-checkbox v-model="form.noticeNewMeeting"
              :disabled='isView'
                >会议通知</el-checkbox
              >
              <el-input
                v-model="form.noticeNewMeetingSort"
                :disabled='isView'
                autocomplete="off"
                style="width: 120px; margin: 0 15px"
                size="mini"
                placeholder="请输入置顶顺序"
              />
              (此处填写的顺序即为学会活动编辑页的会议通知顺序)
            </el-col>
          </el-form-item>
        </div>

        <div v-if="radioType == '1'">
          <el-form-item
            label="通知标题:"
            prop="teacherTitle"
            :label-width="formLabelWidth"
          >
          <el-col :span="24">
              <el-input
                v-model="form.teacherTitle"
                :disabled='isView'
                :maxlength="maxlength"
                placeholder="请输入课程和任课老师标题"
              />
            </el-col>
            <!-- <el-col :span="24">
              <el-input
                v-model="teacherNew.title"
                :maxlength="maxlength"
                placeholder="请输入课程和任课老师标题"
              />
            </el-col> -->
          </el-form-item>

          <el-form-item
            label="作者:"
            prop="author"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="teacherNew.author"
                :disabled='isView'
                :maxlength="maxlength"
                placeholder="请输入作者"
                autocomplete="off"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="上传图片"
            ref="uploadPic"
            prop="uploadPic1"
            class="div-upload-form-item address"
            :label-width="formLabelWidth"
          >
            <div class="div-upload-container" ref="uploadBottom">
              <el-upload
                ref="uploadImg2"
                accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
                list-type="picture-card"
                action=""
                multiple
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove1"
                :on-change="handleChange1"
                :before-upload="handleBefore1"
                :on-exceed="handleExceed"
                :file-list="fileList1"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">建议比例: W: H=5:3  建议尺寸:W*H=640*400 (px)</div>
              </el-upload>
            </div>
          </el-form-item>

          <el-form-item label="详情:" :label-width="formLabelWidth">
            <el-col :span="24">
              <tinymce
                styleName="width: 100%; height: 400px; margin: 5px auto; "
                id="tinymceId"
                :disabled='isView'
                @onChange="onChange2"
                :key="tinymceFlag2"
                :text="teacherNew.content"
                :url="form.newUrlStr"
              />
            </el-col>
          </el-form-item>

          <el-form-item label="" :label-width="formLabelWidth" prop="teacherNewMeeting">
            <el-col :span="24">
              <el-checkbox v-model="form.teacherNewMeeting"
              :disabled='isView'
                >会议通知</el-checkbox
              >
              <el-input
                v-model="form.teacherNewMeetingSort"
                :disabled='isView'
                style="width: 120px; margin: 0 15px"
                autocomplete="off"
                size="mini"
                placeholder="请输入置顶顺序"
              />
              (此处填写的顺序即为学会活动编辑页的会议通知顺序)
            </el-col>
          </el-form-item>
        </div>

        <div v-if="radioType == '2'">
          <el-form-item
            label="小结标题:"
            prop="summaryTitle"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="form.summaryTitle"
                :disabled='isView'
                :maxlength="maxlength"
                placeholder="请输入小结标题"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="作者:"
            prop="author"
            :label-width="formLabelWidth"
          >
            <el-col :span="24">
              <el-input
                v-model="summaryNew.author"
                :disabled='isView'
                :maxlength="maxlength"
                placeholder="请输入作者"
                autocomplete="off"
              />
            </el-col>
          </el-form-item>

          <el-form-item
            label="上传图片"
            ref="uploadPic"
            prop="uploadPic2"
            class="div-upload-form-item address"
            :label-width="formLabelWidth"
          >
            <div class="div-upload-container" ref="uploadBottom">
              <el-upload
                ref="uploadImg3"
                accept="image/png, image/jpeg, image/gif, image/jpg, image/bmp"
                list-type="picture-card"
                action=""
                multiple
                :on-preview="handlePictureCardPreview"
                :on-remove="handleRemove2"
                :on-change="handleChange2"
                :before-upload="handleBefore2"
                :on-exceed="handleExceed"
                :file-list="fileList2"
                :limit="1"
              >
                <i class="el-icon-plus"></i>
                <div slot="tip" class="el-upload__tip">建议比例: W: H=5:3  建议尺寸:W*H=640*400 (px)</div>
              </el-upload>
            </div>
          </el-form-item>

          <el-form-item label="详情:" :label-width="formLabelWidth">
            <el-col :span="24">
              <tinymce
                styleName="width: 100%; height: 400px; margin: 5px auto; "
                id="tinymceId"
                :disabled='isView'
                @onChange="onChange3"
                :key="tinymceFlag3"
                :text="summaryNew.content"
                :url="form.newUrlStr"
              />
            </el-col>
          </el-form-item>

          <el-form-item label="" :label-width="formLabelWidth" prop="summaryNewInfo">
            <el-col :span="24">
              <el-checkbox v-model="form.summaryNewInfo" :disabled='isView'>学会资讯</el-checkbox>
              <el-input
                v-model="form.summaryNewInfoSort"
                :disabled='isView'
                style="width: 120px; margin: 0 15px"
                autocomplete="off"
                size="mini"
                placeholder="请输入置顶顺序"
              />
              (此处填写的顺序即为学会活动编辑页的学会资讯顺序)
            </el-col>
          </el-form-item>
        </div>
      </el-form>
      <el-dialog :visible.sync="dialogVisible">
        <img width="100%" :src="dialogImageUrl" alt="" />
      </el-dialog>
      <!-- 修改状态: 0 已发布, 1 未发布 -->
      <div slot="footer"  v-if="detailId" class="dialog-button">
         <el-button type="primary" v-show="isView"  @click="$router.push('/dictionary-train')">
          返回列表
        </el-button>
        <el-button type="primary" class="confirm-button"  :disabled='isView' @click="handelConfirm('form', 0)">
          发 布
        </el-button>
        <el-button class="confirm-button" :disabled='isView' @click="handelConfirm('form', 1)"
          >保 存</el-button
        >
      </div>
      <div slot="footer" class="dialog-button" v-else>
        <el-button type="primary" @click="handelConfirm('form', 0)">
          立即创建
        </el-button>
        <el-button class="confirm-button" @click="resetForm('form')"
          >重 置</el-button
        >
      </div>
    </div>
  </div>
</template>

<script>
import DictionaryTrainApi from '@/api/dictionaryTrain/index.js'
import { mapRequestActions } from '@/utils'
import tinymce from '@/components/richtext-tinymce/richtext-tinymce'
export default {
  components: {
    tinymce
  },
  data () {
    return {
      loading: false,
      formLabelWidth: '150px',
      maxlength: 200,
      isView: !!this.$route.query.isView || false, // 判断预览
      dialogVisible: false, // 上传预览图片弹窗
      dialogImageUrl: '', // 上传预览图片url

      radioType: '0',
      detailId: this.$route.query.id || '',
      detailList: {},
      imageId: '', // 开班上传图片所需ID
      imageId1: '', // 课程上传图片所需ID
      imageId2: '', // 小结上传图片所需ID
      fileList: [],
      sendFile: [],
      fileList1: [],
      sendFile1: [],
      fileList2: [],
      sendFile2: [],
      tinymceFlag1: 1,
      tinymceFlag2: 2,
      tinymceFlag3: 3,
      form: {
        title: '',
        sort: '', // 置顶顺序
        startTime: '', // 培训开始时间
        registStartTime: '', // 报名开始时间
        newUrlStr: '', // 新url 富文本
        registRemind: '', // 报名须知

        noticeNewMeeting: false, // 开班通知 勾选
        noticeNewMeetingSort: '', // 开班通知 排序
        teacherNewMeeting: false, // 任课老师课程 勾选
        teacherNewMeetingSort: '', // 任课老师课程 排序
        summaryNewInfo: false, // 辞书小结 勾选
        summaryNewInfoSort: '', // 辞书小结 排序

        noticeTitle: '', // 开班通知标题
        teacherTitle: '', // 教师和课程标题
        summaryTitle: '' // 培训小结标题
      },
      noticeNew: {
        // 开班通知对象
        title: '',
        author: '',
        // coverFileId: '',
        content: ''
      },
      teacherNew: {
        // 培训课程和任课老师
        title: '',
        author: '',
        // coverFileId: '',
        content: ''
      },
      summaryNew: {
        // 培训小结
        title: '',
        author: '',
        // coverFileId: '',
        content: ''
      },
      rule: {
        title: [
          { required: true, message: '请输入培训班名称', trigger: 'change' }
        ],
        startTime: [
          { required: true, message: '请选择培训时间', trigger: 'change' }
        ],
        registStartTime: [
          { required: true, message: '请选择报名时间', trigger: 'change' }
        ],
        address: [
          { required: true, message: '请输入培训班地点', trigger: 'change' }
        ],
        noticeTitle: [{ required: true, message: '请输入开班通知标题', trigger: 'change' }],
        teacherTitle: [{ required: true, message: '请输入课程和任课老师标题', trigger: 'change' }],
        summaryTitle: [{ required: true, message: '请输入培训小结标题', trigger: 'change' }],
        uploadPic: [{ required: true, message: '请上传图片', trigger: 'change' }],
        uploadPic1: [{ required: true, message: '请上传图片', trigger: 'change' }],
        uploadPic2: [{ required: true, message: '请上传图片', trigger: 'change' }]
      }
    }
  },
  created () {
    if (this.detailId) {
      this.handleQueryDetailById()
    }
  },
  activated () {
    this.tinymceFlag1++
    this.tinymceFlag2++
    this.tinymceFlag3++
  },
  methods: {
    ...mapRequestActions(DictionaryTrainApi),
    handelConfirm (formName, type) {
      if ((this.fileList && this.fileList.length > 0) || (this.fileList1 && this.fileList1.length > 0) || (this.fileList2 && this.fileList2.length > 0)) {
        this.rule.uploadPic = []
        this.rule.uploadPic1 = []
        this.rule.uploadPic2 = []
        this.$refs.uploadPic.clearValidate()
      }

      // this.$nextTick(() => {
      // if (this.fileList && this.fileList.length > 0) {
      //   this.rule.uploadPic = []
      //   this.$refs.uploadPic.clearValidate()
      // } else
      // if (this.fileList1 && this.fileList1.length > 0) {
      //   this.rule.uploadPic1 = []
      //   this.$refs.uploadPic1.clearValidate()
      // }
      // else
      // if (this.fileList2 && this.fileList2.length > 0) {
      //   this.rule.uploadPic2 = []
      //   this.$refs.uploadPic2.clearValidate()
      // }
      // })

      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 编辑状态 且 点击发布
          // console.log('tijiao=', this.form)
          const newArr = Object.assign({}, this.form, {

            status: type,
            startTime: this.form.startTime[0],
            finishTime: this.form.startTime[1],
            address: this.form.address,
            registStartTime: this.form.registStartTime[0],
            registEndTime: this.form.registStartTime[1],

            noticeNew: {
              title: this.form.noticeTitle,
              coverFileId: this.imageId,
              author: this.noticeNew.author ? this.noticeNew.author : '',
              content: this.noticeNew.content
              // .replaceAll('&ldquo;', '<doub>“</doub>').replaceAll('&rdquo;', '<doub>”</doub>')
            },
            teacherNew: {
              title: this.form.teacherTitle,
              author: this.teacherNew.author ? this.teacherNew.author : '',
              coverFileId: this.imageId1,
              content: this.teacherNew.content
              // .replaceAll('&ldquo;', '<doub>“</doub>').replaceAll('&rdquo;', '<doub>”</doub>')
            },
            summaryNew: {
              title: this.form.summaryTitle,
              author: this.summaryNew.author ? this.summaryNew.author : '',
              coverFileId: this.imageId2,
              content: this.summaryNew.content
              // .replaceAll('&ldquo;', '<doub>“</doub>').replaceAll('&rdquo;', '<doub>”</doub>')
            },
            coverFileId: this.imageId
          })
          if (this.detailId && type === 0) {
            this.updateDetailTrainAction({
              id: this.detailId,
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('编辑成功！')
                this.$router.push('/dictionary-train')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else if (this.detailId && type === 1) {
            // 编辑状态 且 点击保存
            this.updateDetailTrainAction({
              id: this.detailId,
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('保存成功！')
                this.$router.push('/dictionary-train')
              } else {
                this.$message.error('操作失败')
              }
            })
          } else {
            // 点击新增数据
            this.addTrainInfoAction({
              ...newArr
            }).then((res) => {
              if (res.status) {
                this.$message.success('新增成功！')
                this.$router.push('/dictionary-train')
              } else {
                this.$message.error('操作失败')
              }
            })
          }
        } else {
          // todo
        }
      })
    },

    /**
     * 新建页面 -- 重置按钮
     */
    resetForm (formName) {
      this.$refs[formName].resetFields()
      // this.$refs.uploadImg1.clearFiles()
      // this.$refs.uploadImg2.clearFiles()
      // this.$refs.uploadImg3.clearFiles()
      this.imageId = ''
      this.imageId1 = ''
      this.imageId2 = ''
      this.fileList = []
      this.fileList1 = []
      this.fileList2 = []
      this.form.noticeNewMeetingSort = ''
      this.form.teacherNewMeetingSort = ''
      this.form.summaryNewInfoSort = ''
      this.noticeNew = []
      this.teacherNew = []
      this.summaryNew = []
    },

    /**
     * 根据ID 查询详情
     */
    async handleQueryDetailById () {
      const resultData = await this.queryDetailByIdAction({
        id: this.detailId
      })
      if (resultData.status) {
        this.form = resultData.result
        // console.log('resultData.result', resultData.result)

        this.form.startTime = [
          this.getMyDate(resultData.result.startTime),
          this.getMyDate(resultData.result.finishTime)
        ]
        this.$set(this.form, 'startTime', this.form.startTime)

        this.form.registStartTime = [
          this.getMyDate(resultData.result.registStartTime),
          this.getMyDate(resultData.result.registEndTime)
        ]
        this.$set(this.form, 'registStartTime', this.form.registStartTime)

        // 1. 开班通知对象
        this.noticeNew = resultData.result.noticeNew || {}
        this.imageId = resultData.result.noticeNew ? resultData.result.noticeNew.coverFileId : ''
        if (resultData.result.noticeNew && resultData.result.noticeNew.coverFile) {
          this.fileList.push({
            url:
              this.BaseUrl.baseUrl +
              resultData.result.noticeNew.coverFile.relativePath
          })
        }
        // 为防止编辑过程中 输入框不可点击编辑  使用this.$set()
        this.noticeNew.content = this.$set(this.form, this.noticeNew.content, resultData.result.noticeNew.content)
        // this.noticeNew.content = resultData.result.noticeNew.content
        if (resultData.result.noticeNew) {
          this.form.noticeTitle = this.$set(this.form, 'noticeTitle', resultData.result.noticeNew.title)
        }
        // 2.  课程和任课老师对象
        this.teacherNew = resultData.result.teacherNew || {}
        this.imageId1 = resultData.result.teacherNew ? resultData.result.teacherNew.coverFileId : ''
        if (resultData.result.teacherNew && resultData.result.teacherNew.coverFile) {
          this.fileList1.push({
            url: this.BaseUrl.baseUrl +
              resultData.result.teacherNew.coverFile.relativePath
          })
        }
        if (resultData.result.teacherNew) {
          this.form.teacherTitle = this.$set(this.form, 'teacherTitle', resultData.result.teacherNew.title)
        }
        // 3. 培训小结对象
        this.summaryNew = resultData.result.summaryNew || {}
        this.imageId2 = resultData.result.summaryNew ? resultData.result.summaryNew.coverFileId : ''
        if (resultData.result.summaryNew) {
          this.form.summaryTitle = this.$set(this.form, 'summaryTitle', resultData.result.summaryNew.title)
        }
        if (resultData.result.summaryNew && resultData.result.summaryNew.coverFile) {
          this.fileList2.push({
            url:
             this.BaseUrl.baseUrl +
              resultData.result.summaryNew.coverFile.relativePath || ''
          })
        }
      }
    },

    onChange1 (content, urls) {
      this.noticeNew.content = content
      // .replaceAll('&ldquo;', '<doub>“</doub>').replaceAll('&rdquo;', '<doub>”</doub>')
      // this.form.newUrlStr = urls
      // if (content) {
      //   this.$refs.form.validateField('description')
      // }
    },
    onChange2 (content, urls) {
      this.teacherNew.content = content
    },
    onChange3 (content, urls) {
      this.summaryNew.content = content
    },

    handlePictureCardPreview (file) {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },

    handleRemove (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {
      } else {
        const index = this.fileList.findIndex((item) => {
          return e.uid === item.uid
        })
        this.fileList.splice(index, 1)
        this.sendFile.splice(index, 1)
        if (this.sendFile && this.sendFile.length === 0) {
          this.rule.uploadPic = [
            { required: true, message: '请上传图片', trigger: 'change' }
          ]
          this.$refs.form.validateField('uploadPic')
        }
      }
    },
    handleRemove1 (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {
      } else {
        const index = this.fileList1.findIndex((item) => {
          return e.uid === item.uid
        })
        this.fileList1.splice(index, 1)
        this.sendFile1.splice(index, 1)
        if (this.sendFile1 && this.sendFile1.length === 0) {
          this.rule.uploadPic1 = [
            { required: true, message: '请上传图片', trigger: 'change' }
          ]
          this.$refs.form.validateField('uploadPic')
        }
      }
    },
    handleRemove2 (e) {
      // 判断是否是删除，因为添加时也走该方法，若isRemove为true时则走该方法
      if (!this.isRemove) {
      } else {
        const index = this.fileList2.findIndex((item) => {
          return e.uid === item.uid
        })
        this.fileList2.splice(index, 1)
        this.sendFile2.splice(index, 1)
        if (this.sendFile2 && this.sendFile2.length === 0) {
          this.rule.uploadPic2 = [
            { required: true, message: '请上传图片', trigger: 'change' }
          ]
          this.$refs.form.validateField('uploadPic')
        }
      }
    },
    handleChange () {},
    handleChange1 () {},

    handleChange2 () {},

    handleBefore (file) {
      this.$refs.uploadPic.clearValidate()
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)

      const that = this
      that.sendFile = []
      that.fileList = []
      that.sendFile.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile.forEach((element) => {
          formData.append('file', element)
        })
        formData.append('bizeType', '辞书培训班')
        that.upLoadDataAction(formData).then((res) => {
          if (res.status) {
            that.imageId = res.result.id || ''
            that.linkUrl = res.result.thumbnailUrl || ''
          }
        })
        image.src = data
      }
      return false
    },
    // 课程和任课老师
    handleBefore1 (file) {
      this.$refs.uploadPic.clearValidate()
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)

      const that = this
      that.sendFile1 = []
      that.fileList1 = []
      that.sendFile1.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList1.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile1.forEach((element) => {
          formData.append('file', element)
        })
        formData.append('bizeType', '辞书培训班')
        that.upLoadDataAction(formData).then((res) => {
          if (res.status) {
            that.imageId1 = res.result.id || ''
          }
        })
        image.src = data
      }
      return false
    },
    // 课程小结2
    handleBefore2 (file) {
      this.$refs.uploadPic.clearValidate()
      this.isRemove = false
      const read = new FileReader()
      read.readAsDataURL(file)

      const that = this
      that.sendFile2 = []
      that.fileList2 = []
      that.sendFile2.push(file)
      read.onload = function (e) {
        const data = e.target.result
        const image = new Image()
        image.onload = () => {
          const src = e.target.result
          that.fileList2.push({ name: file.name, url: src })
          that.isRemove = true
        }
        var formData = new FormData()
        that.sendFile2.forEach((element) => {
          formData.append('file', element)
        })
        formData.append('bizeType', '辞书培训班')
        that.upLoadDataAction(formData).then((res) => {
          if (res.status) {
            that.imageId2 = res.result.id || ''
          }
        })
        image.src = data
      }
      return false
    },

    handleExceed () {
      this.$message.warning('最多可以上传1张图片')
    },
    // 获取年月日
    // 将毫秒值转为时间年/月/日 时分秒
    getMyDate (str) {
      var oDate = new Date(str)
      var oYear = oDate.getFullYear()
      var oMonth = oDate.getMonth() + 1
      var oDay = oDate.getDate()
      var oHour = oDate.getHours()
      var oMin = oDate.getMinutes()
      var oSen = oDate.getSeconds()
      var oTime = oYear + '-' + this.addZero(oMonth) + '-' + this.addZero(oDay) + ' ' + this.addZero(oHour) + ':' + this.addZero(oMin) + ':' + this.addZero(oSen)
      return oTime
    },

    // 补零操作
    addZero (num) {
      if (parseInt(num) < 10) {
        num = '0' + num
      }
      return num
    }
  }
}
</script>

<style lang='less' scoped>
.container {
  padding: 10px;
}
.el-form {
  max-width: 85%;
  min-width: 900px;
  margin-right: auto;
  padding: 20px 30px;
  /deep/ .el-upload-list--picture-card .el-upload-list__item {
    width: 125px;
    height: 125px;
  }
  .address {
    /deep/ .el-form-item__label:before {
      content: "*" !important;
      color: #f56c6c !important;
      margin-right: 4px !important;
    }
  }
}
.div-upload-form-item {
  position: relative;
  .div-upload-bottom {
    position: absolute;
    right: 0;
    top: 100px;
  }
  .div-upload-container {
    display: block;
    height: 150px;
    float: left;
    text-align: left;
    // overflow: hidden;
    transition: height 0.75s;
    /deep/ .el-upload {
      width: 125px;
      height: 125px;
      line-height: 125px;
    }
    .el-upload__tip{
      margin-top: 0;
      line-height: 26px;
      padding-bottom: 5px;
    }
  }
}

.el-upload-dragger .el-icon-upload {
  margin: 25px 0 16px;
}
.dialog-button {
  text-align: left;
  margin-left: 20%;
  margin-top: 40px;
  .confirm-button {
    margin-left: 30px;
  }
}
.select_button {
  float: left;
}
// /deep/  .el-upload--picture ,.el-button--small{
//   float: left;
// }
.el-col {
  text-align: left;
}
</style>
